<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18sxziQ/tc-custom/9781423612223.jpg?1736954282814" alt="This image is the cover for the book Camp Cooking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Camp Cooking
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Photos, anecdotes, and outdoor-cooking recipes celebrating the history of the U.S. Forest Service.</b><br/><br/> Dedicated protectors of our national forests and grasslands, Forest Service agents live much of their lives outdoors, and that includes mealtimes. In decades past, rangers’ wives prepared meals with limited resources as they accompanied their husbands in the field, often supplementing cooking with k-rations cooked over an open fire. In rustic and remote locations, delicious, time-tested creations were prepared and served, including Dutch Oven Beer Bread, Parmesan Mashed Potatoes, Pioneer Night Stew, and Creamy Pumpkin Pie.<br/>  <br/> Here, the National Museum of Forest Service History presents a unique cookbook that celebrates decades of camp cooking by countless Forest Service agents in the field. Featuring legendary recipes for Dutch oven meals, open-fire dishes, and other tasty outdoor specialties used daily in the early days of the Forest Service, <i>Camp Cooking</i> also includes photos and anecdotes that tell the whole history of these brave and hardy individuals.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The National Museum of Forest Service History
      </h2>
      
      <p class="authorDescription body article">To pay tribute to decades of dedication of Forest Service employees, the Intermountain Region and the National Museum of Forest Service History (http://www.nmfs-history.net) are proud to present this collectible cookbook. For more information, visit http://www.fs.fed.us/newcentury/cookbook.htm.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0db6a324